module.exports = __webpack_public_path__ + "static/media/pla_rev_cam.225fd836.png";